import { Component, ChangeDetectionStrategy, input, InputSignal } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { TranslatePipe, IconComponent, HrefDirective, ButtonComponent, OverlayToggleDirective, OverlayComponent, OverlayHeaderComponent, IconFlagComponent } from '@tdwb/core';
import { EnrollmentStatus, FplAccountGroupData } from '../fpl.domain';

@Component({
  selector: 'td-wb-fpl-introduction',
  templateUrl: './fpl-introduction.component.html',
  styleUrls: ['./fpl-introduction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    TranslateDirective,
    TranslatePipe,
    IconComponent,
    HrefDirective,
    OverlayToggleDirective,
    OverlayComponent,
    OverlayHeaderComponent,
    IconFlagComponent
  ]
})
export class FplIntroductionComponent {
  readonly accountGroups: InputSignal<Array<FplAccountGroupData>> = input<Array<FplAccountGroupData>>([]);
  readonly enrollmentStatus: InputSignal<EnrollmentStatus> = input<EnrollmentStatus>(null);
  readonly modalView: InputSignal<boolean> = input<boolean>(false);

  get totalAccounts(): number {
    return this.accountGroups().reduce((count: number, group: FplAccountGroupData) => count + (group.accounts?.length || 0), 0);
  }
}
